import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("wattline_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      if (path !== "/login") {
        localStorage.removeItem("wattline_token");
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Suggerimenti tipo società alternativi quando OpenAPI rifiuta una visura
// perché la P.IVA non appartiene alla forma giuridica selezionata.
const _VISURA_ALT_TYPES = {
  visura_ord_societa_capitali: "Società di persone (S.n.c., S.a.s.) o Impresa individuale",
  visura_ord_societa_persone: "Società di capitali (S.r.l., S.p.A.) o Impresa individuale",
  visura_ord_impresa_individuale: "Società di capitali (S.r.l., S.p.A.) o Società di persone (S.n.c., S.a.s.)",
};

/**
 * Traduce in italiano gli errori OpenAPI noti relativi al mismatch del tipo
 * società sulle visure camerali. Ritorna null se l'errore non è riconosciuto,
 * così il chiamante può fare fallback al messaggio originale.
 *
 * Pattern coperti (dal log OpenAPI.it):
 *   - "the cf_piva_id does not belong to a societa capitale"
 *   - "the cf_piva_id does not belong to a societa di persone"
 *   - "the cf_piva_id does not belong to a impresa individuale"
 *   - "OpenAPI.it 404: ... does not belong to ..."
 */
const _PLANIMETRIA_IDS = new Set(["planimetria_catastale_pdf"]);

export function humanizeServiceError(raw, currentServiceId) {
  if (raw == null) return null;
  const text = String(formatApiError(raw)).toLowerCase();
  if (text.includes("does not belong to")) {
    const alt = _VISURA_ALT_TYPES[currentServiceId] || "un altro tipo di società";
    return `Questa azienda non risulta del tipo selezionato. Prova con ${alt}.`;
  }
  if (_PLANIMETRIA_IDS.has(currentServiceId)) {
    if (text.includes("401") || text.includes("wrong token") || text.includes("unauthorized")) {
      return "Configurazione OpenAPI non valida: il token è stato rifiutato. Nessun costo addebitato — contatta l'amministratore Wattline.";
    }
    if (text.includes("402") || text.includes("credito") || text.includes("payment") || text.includes("insufficient")) {
      return "Credito OpenAPI esaurito: la richiesta non è stata evasa. Ricarica il credito su console.openapi.com e riprova.";
    }
    if (text.includes("404") || text.includes("non trovat") || text.includes("not found")) {
      return "Immobile non trovato al catasto: verifica provincia, comune, foglio e particella e riprova.";
    }
    if (text.includes("422") || text.includes("non processabile") || text.includes("unprocessable") || text.includes("non disponibile")) {
      return "Documento non disponibile: per questo immobile la planimetria rasterizzata non risulta presente nell'archivio catastale.";
    }
  }
  return null;
}

export default api;
